import React, { useEffect, useState, useCallback } from "react";
import RankedProfile from "ranked-profile";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import MonetizationButton from "../MonetizationButton";
import ProgressBar from "../ProgressBar";
import Unlocks from "../Unlocks";
import Avatar from "../../assets/avatar.jpg";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
  },
  header: {
    fontSize: 36,
    marginTop: 20,
    marginBottom: 20,
    fontWeight: 400,
  },
  details: {
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: "1 0 auto",
  },
  cover: {
    width: 151,
  },
}));

const rp = RankedProfile();

const CURRENT_LEVEL = 1;
const CURRENT_XP = 0;

const Profile = () => {
  const [level, setLevel] = useState(CURRENT_LEVEL);
  const [xp, setXp] = useState(CURRENT_XP);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const classes = useStyles();

  const toggleSnackbar = useCallback(() => {
    setSnackbarOpen(!snackbarOpen);
  }, [snackbarOpen]);

  const levelUp = useCallback(
    (level) => {
      toggleSnackbar();
      setLevel(level);
    },
    [toggleSnackbar]
  );

  useEffect(() => {
    rp.init({
      level: CURRENT_LEVEL,
      xp: CURRENT_XP,
      levelThresholds: [10, 20, 50],
      multiplier: 10000,
      onXPUpdate: setXp,
      onLevelUp: levelUp,
    });

    return () => rp.cleanup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Typography component="h1" variant="h1" className={classes.header}>
        Ranked Profiles Demo
      </Typography>
      <MonetizationButton />
      <Card className={classes.root}>
        <CardMedia
          className={classes.cover}
          image={Avatar}
          title="User avatar"
        />
        <div className={classes.details}>
          <CardContent className={classes.content}>
            <Typography component="h5" variant="h5">
              Keith
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              Current Level: {level}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              Current XP: {xp.toFixed(2)}
              <>
                <div>
                  XP Until Next Level:{" "}
                  {rp.isActive() ? rp.getExperienceToNextLevel() : 10}
                </div>
                <ProgressBar instance={rp} />
              </>
            </Typography>
          </CardContent>
        </div>
      </Card>
      <Unlocks level={level} />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={toggleSnackbar}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity="success"
          onClose={toggleSnackbar}
        >
          Level up!
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default Profile;
